import { maxWidth } from "../../shared/styleconfig";

import { useEffect, useState } from "react";
import { Criterion } from "./components/Criterion";
import { DNDActionButtons } from "./components/dndActionButtons";
import { LeftPanel } from "./components/LeftPanel";
import RunTestDialog from "./components/RunTestDialog";
import { TAAPI_API_KEY } from "../../shared/taapiConfig";
import axios from "axios";
import {
  errorToaster,
  successToaster,
  warningToaster,
} from "../../util/toaster";
import { algoValidations, getStockIndicatorValue } from "../../services/Stock";
import { ReactComponent as NoMobileIcon } from "../../assets/image/other/no-mobile.svg";
import { useMediaQuery } from "@mui/material";
import { useUser } from "../../context/UserContext";
import { useNavigate, useParams } from "react-router-dom";
import Supabase from "../../backend/client";

const DND = ({ mode }) => {
  const matches = useMediaQuery("(min-width:768px)");
  const [buyBoard, setBuyBoard] = useState([]);
  const [sellBoard, setSellBoard] = useState([]);
  const [dndRequest, setDNDRequest] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedStockList, setSelectedStockList] = useState([""]);
  const navigate = useNavigate();
  const user = useUser();
  const params = useParams();
  const [algoDetails, setAlgoDetails] = useState(null);

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      navigate("/");
    }
    document.title = "Algo Engine";
  }, [user?.user?.id]);

  const [initiateRun, setInitiateRun] = useState(false);
  const [algoResult, setAlgoResult] = useState([]);
  const [runWithSuccess, setRunWithSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [operatorTypes, setOperatorTypes] = useState({
    buy: "",
    sell: "",
  });

  const setAlgoData = (type, data) => {
    if (type === "operator") {
      const childObj = dndRequest[data.index];
      childObj["operationType"] = data.operator;
      const newObj = [...dndRequest];
      newObj[data.index] = childObj;
      setDNDRequest([...newObj]);
      
      // Update the operatorTypes state based on which algo index is being modified
      setOperatorTypes(prev => ({
        ...prev,
        [data.index === 0 ? 'buy' : 'sell']: data.operator
      }));
      console.log("Updated operator to:", data.operator, "for", data.index === 0 ? 'buy' : 'sell');
    } else if (type === "shares") {
      const childObj = dndRequest[data.index];
      childObj["shares"] = data.shares;
      const newObj = [...dndRequest];
      newObj[data.index] = childObj;
      setDNDRequest([...newObj]);
    } else if (type === "leftLogicValue") {
      const childObj = dndRequest[data.index];
      childObj["leftLogic"]["type"] = "number";
      childObj["leftLogic"]["value"] = data.value;
      const newObj = [...dndRequest];
      newObj[data.index] = childObj;
      setDNDRequest([...newObj]);
    } else if (type === "leftLogicComponent") {
      const childObj = dndRequest[data.index];
      childObj["leftLogic"]["type"] = "component";
      childObj["leftLogic"]["componentName"] = data.componentName;
      childObj["leftLogic"]["timeRange"] = data.timeRange;
      childObj["leftLogic"]["status"] = data.status;
      const newObj = [...dndRequest];
      newObj[data.index] = childObj;
      setDNDRequest([...newObj]);
    } else if (type === "leftLogicComponentInput") {
      const childObj = dndRequest[data.index];
      childObj["leftLogic"]["timeRange"] = data.timeRange;
      const newObj = [...dndRequest];
      newObj[data.index] = childObj;
      setDNDRequest([...newObj]);
    } else if (type === "leftLogicComponentInterval") {
      const childObj = dndRequest[data.index];
      childObj["leftLogic"]["interval"] = data.interval;
      const newObj = [...dndRequest];
      newObj[data.index] = childObj;
      setDNDRequest([...newObj]);
    } else if (type === "leftLogicComponentStatus") {
      const childObj = dndRequest[data.index];
      childObj["leftLogic"]["status"] = data.status;
      const newObj = [...dndRequest];
      newObj[data.index] = childObj;
      setDNDRequest([...newObj]);
    } else if (type === "rightLogicValue") {
      const childObj = dndRequest[data.index];
      childObj["rightLogic"]["type"] = "number";
      childObj["rightLogic"]["value"] = data.value;
      const newObj = [...dndRequest];
      newObj[data.index] = childObj;
      setDNDRequest([...newObj]);
    } else if (type === "rightLogicComponent") {
      const childObj = dndRequest[data.index];
      childObj["rightLogic"]["type"] = "component";
      childObj["rightLogic"]["componentName"] = data.componentName;
      childObj["rightLogic"]["timeRange"] = data.timeRange;
      childObj["rightLogic"]["status"] = data.status;
      const newObj = [...dndRequest];
      newObj[data.index] = childObj;
      setDNDRequest([...newObj]);
    } else if (type === "rightLogicComponentInput") {
      const childObj = dndRequest[data.index];
      childObj["rightLogic"]["timeRange"] = data.timeRange;
      const newObj = [...dndRequest];
      newObj[data.index] = childObj;
      setDNDRequest([...newObj]);
    } else if (type === "rightLogicComponentInterval") {
      const childObj = dndRequest[data.index];
      childObj["rightLogic"]["interval"] = data.interval;
      const newObj = [...dndRequest];
      newObj[data.index] = childObj;
      setDNDRequest([...newObj]);
    } else if (type === "rightLogicComponentStatus") {
      const childObj = dndRequest[data.index];
      childObj["rightLogic"]["status"] = data.status;
      const newObj = [...dndRequest];
      newObj[data.index] = childObj;
      setDNDRequest([...newObj]);
    } else if (type === "errorAlgo") {
      const childObj = dndRequest[data.index];
      childObj["error"] = data.error;
      const newObj = [...dndRequest];
      newObj[data.index] = childObj;
      setDNDRequest([...newObj]);
    }
  };

  const handleRunTest = () => {
    const isValidAlgo = algoValidations(dndRequest);
    if (isValidAlgo) {
      setOpen(true);
    }
  };

  const makeInitialAlgos = (type, stock = "") => {
    // Default operators based on type
    const defaultOperator = type === "BUY" ? "crossover_above" : "crossover_below";
    
    setDNDRequest((request) => [
      ...request,
      {
        type: type,
        operationType: defaultOperator,
        leftLogic: {
          type: "", //component or number
          value: 0, // This will be addressed if above type is number
          componentName: "", // RSI, EMA etc can be the value
          timeRange: 0,
          interval: "1d",
          status: "", // Close or Open can be the value
        },
        rightLogic: {
          type: "", //component or number
          value: 0, // This will be addressed if above type is number
          componentName: "", // RSI, EMA etc can be the value
          timeRange: 0,
          interval: "1d",
          status: "", // Close or Open can be the value
        },
        shares: 0,
        error: false,
        stock: stock,
      },
    ]);
  };

  const getAlgoData = async () => {
    setAlgoDetails(null);
    const { data, error } = await Supabase.from("algos")
      .select("*")
      .eq("id", params?.id);
    if (error) {
      errorToaster(error?.message);
      return navigate("/dashboard");
    }
    if (data?.length > 0) {
      console.log("data[0]", data[0]);
      setAlgoDetails(data[0]);
      setSelectedStockList(JSON.parse(data[0]?.backtest_details)["stocks"]);
      const buyValue = JSON.parse(data[0]?.left_logic);

      const sellValue = JSON.parse(data[0]?.right_logic);
      setOperatorTypes({
        buy: buyValue[0].operationType,
        sell: sellValue[0].operationType,
      });
      //   const rightValue = { ...JSON.parse(data[0]?.right_logic) };
      //   const arr = [
      //     {
      //       ...leftValue[0],
      //       //operationType: leftValue[0]?.operationType === "<" ? "<" : ">",
      //     },
      //     {
      //       ...rightValue[0],
      //       //operationType: rightValue[0]?.operationType === "<" ? "<" : ">",
      //     },
      //   ];
      //console.log("arr", arr);
      setDNDRequest([...buyValue, ...sellValue]);
    }
  };

  useEffect(() => {
    if (mode === "update") {
      setDNDRequest([]);
      getAlgoData();
    } else {
      setDNDRequest([]);
      makeInitialAlgos("BUY");
      makeInitialAlgos("SELL");
      
      // Initialize operatorTypes with default values for new strategies
      setOperatorTypes({
        buy: "crossover_above",
        sell: "crossover_below"
      });
    }
  }, [mode]);

  useEffect(() => {
    console.log("selectedStockListselectedStockList", selectedStockList);
  }, [selectedStockList]);
  useEffect(() => {
    if (algoResult.length === dndRequest.length && algoResult.length > 0) {
      let hasError = false;
      algoResult.forEach((item) => {
        if (item[0].satisfy === false) {
          hasError = true;
        }
      });
      if (!hasError) {
        successToaster(
          "Algo run was successfull. All the values are perfect in selected stock algo."
        );
      } else {
        errorToaster("Error in algo values.");
      }
    }
  }, [algoResult]);

  useEffect(() => {
    console.log("operatorTypes", operatorTypes);
  }, [operatorTypes]);

  // Check if we have a recent backtest stored in localStorage
  const checkStoredBacktest = () => {
    if (window.localStorage) {
      const storedStats = window.localStorage.getItem('lastBacktestStats');
      const storedTime = window.localStorage.getItem('lastBacktestTime');
      
      if (storedStats && storedTime) {
        // Check if the backtest was run in the last 30 minutes
        const lastTestTime = new Date(storedTime);
        const currentTime = new Date();
        const timeDiffMinutes = (currentTime - lastTestTime) / (1000 * 60);
        
        if (timeDiffMinutes < 30) {
          // If we have a recent backtest, consider it valid
          try {
            const parsedStats = JSON.parse(storedStats);
            if (parsedStats?.success) {
              setRunWithSuccess(true);
              return true;
            }
          } catch (err) {
            console.error("Error parsing stored backtest stats:", err);
          }
        }
      }
    }
    return false;
  };

  // Add this effect to check localStorage when the component mounts
  useEffect(() => {
    checkStoredBacktest();
  }, []);

  return (
    <div>
      <div className=" flex flex-col justify-center items-center lg:hidden w-full h-[100vh] ">
        <NoMobileIcon className="w-[200px] h-[200px]" />
        <h3>For better experience please use desktop or laptop.</h3>
      </div>

      {open && matches ? (
        <RunTestDialog
          open={open && matches}
          handleClose={() => setOpen(false)}
          dndRequest={dndRequest}
          setSelectedStockList={setSelectedStockList}
          selectedStockList={selectedStockList}
        />
      ) : (
        ""
      )}
      <div className=" md:hidden lg:block ">
        <div
          className={`h-[calc(100vh-71px)] w-[100%] pt-[60px] pb-[20px] font-[Helvetica LT Std] `}>
          <div
            className={`w-full h-full ${maxWidth} mx-auto gap-[15px] flex flex-row my-[10px]`}>
            <LeftPanel />
            <Criterion
              criterionData={buyBoard}
              setCriterionData={setBuyBoard}
              criterionType="BUY"
              setDNDRequest={setDNDRequest}
              dndRequest={dndRequest}
              setAlgoData={setAlgoData}
              operatorTypes={operatorTypes}
            />
            <Criterion
              criterionData={sellBoard}
              setCriterionData={setSellBoard}
              criterionType="SELL"
              setDNDRequest={setDNDRequest}
              dndRequest={dndRequest}
              setAlgoData={setAlgoData}
              operatorTypes={operatorTypes}
            />
          </div>
          <DNDActionButtons
            dndRequest={dndRequest}
            selectedStockList={selectedStockList}
            runTestAlgo={handleRunTest}
            algoDetails={algoDetails}
          />
        </div>
      </div>
    </div>
  );
};
export default DND;
